import React from "react";
import { Clock, Store } from "lucide-react";

interface HeaderProps {
  dateLabel: string;
  selectedLojaId?: number;
  selectedLojaNome?: string;
  criterio?: string;
}

export const Header: React.FC<HeaderProps> = ({
  dateLabel,
  selectedLojaId,
  selectedLojaNome,
  criterio,
}) => {
  return (
    <div className="mt-3 shrink-0 px-3 py-1.5 text-center sm:mt-4 sm:px-4 sm:py-2">
      <h1 className="mb-1 bg-gradient-to-r from-yellow-300 to-white bg-clip-text text-3xl font-black text-transparent sm:text-5xl lg:text-6xl">
        RANKING FICHA DIÁRIA
      </h1>
      <div className="mb-2 flex flex-col items-center justify-center gap-0.5 text-base opacity-75 sm:mb-3 sm:flex-row sm:gap-2 sm:text-lg lg:text-xl">
        <span className="flex items-center gap-1.5">
          <Clock className="h-4 w-4 sm:h-5 sm:w-5" />
          {dateLabel}
        </span>
        {selectedLojaId && selectedLojaNome && (
          <>
            <span className="hidden sm:inline">•</span>
            <span className="flex items-center gap-1.5">
              <Store className="h-4 w-4 sm:h-5 sm:w-5" />
              {selectedLojaNome}
            </span>
          </>
        )}
      </div>

      <p className="mx-auto max-w-4xl text-sm font-semibold leading-snug text-yellow-200 sm:text-lg lg:text-xl">
        {criterio ||
          "Nota de 0 a 10. O melhor do dia vale 10. Produzir mais e mais rápido sobe a nota."}
      </p>
    </div>
  );
};
